var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rpcs-tag"},[_c('span',{class:_vm.classes},[_c('span',{staticClass:"be-rpcs__label"})])])}
var staticRenderFns = []

export { render, staticRenderFns }